import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useMount } from 'react-use';

import ItemDetails from '../item-details/ItemDetails';
import { compilePath } from '../../../../common/utils/helpers/routes';
import { selectActiveItem } from '../../store';
import {
  clearFormState,
  clearLastSentEditMetadata,
  clearRoutablePoints,
  longPressLocationChanged,
} from '../../../../common/store/item-edit';
import {
  getItemMetricParams,
  getItemType,
} from '../../../../common/utils/helpers/item';
import { ITEM_TYPES } from '../../../../common/utils/constants/constants';
import { selectSearchParams } from '../../../../common/store/search';

const ItemDetailsPage = ({ ...props }) => {
  const item = useSelector(selectActiveItem);
  const searchParams = useSelector(selectSearchParams);
  const history = useHistory();
  const dispatch = useDispatch();

  useMount(() => {
    dispatch(clearFormState());
    dispatch(clearRoutablePoints());
    dispatch(clearLastSentEditMetadata());
    dispatch(longPressLocationChanged(null));
  });

  if (!item) {
    return (
      <Redirect
        to={{
          pathname: compilePath('results-list'),
          search: history.location.search,
        }}
      />
    );
  }

  return (
    <ItemDetails
      item={item}
      {...props}
      onEdit={() => {
        history.push({
          pathname: compilePath('edit'),
          search: history.location.search,
        });
        const metricParams = getItemMetricParams(item, searchParams);

        switch (getItemType(item)) {
          case ITEM_TYPES.address:
            analytics.track('Open Edit Address', metricParams);
            break;
          case ITEM_TYPES.poi:
            analytics.track('Open Edit POI', metricParams);
            break;
        }
      }}
      onCloseOrRemove={() =>
        history.push({
          pathname: compilePath('remove-root'),
          search: history.location.search,
        })
      }
    />
  );
};

export default ItemDetailsPage;
